// extracted by mini-css-extract-plugin
export default {"dialog":"WelcomeDialog_dialog__8Gic1","formButton":"WelcomeDialog_formButton__N3CRw"};